/* eslint-disable react/no-unknown-property */
import React from 'react';
import {
  Icon,
  ICON_MAP_MARKER_OUTLINE,
  Message, Popover, PopoverProps, Spacing,
  Text,
} from '@doveit/bricks';
import { Company } from '../../../providers/api/dtos';
import PopoverPreviewSkeleton from '../../../components/popover-preview/PopoverPreview.skeleton';
import PopoverPreview from '../../../components/popover-preview/PopoverPreview';
import * as styles from './ViewCompanyPopoverPreview.style';
import useCompany from '../../hooks/use-company/useCompany';
import CompanyAvatar from '../../components/company-avatar/CompanyAvatar';

interface WithCompany {
  company: Company,
  companyIdOrVat?: never,
}

interface WithCompanyIdOrVat {
  companyIdOrVat: NonNullable<Company['id'] | Company['vatNumber']>,
  company?: never,
}

interface BaseViewContactPopoverPreviewProps extends React.AriaAttributes {
  trigger: PopoverProps['trigger'],
  hideAction?: boolean,
}

export type ViewCompanyPopoverPreviewProps = BaseViewContactPopoverPreviewProps & (WithCompany | WithCompanyIdOrVat);

const ViewCompanyPopoverPreview: React.FC<ViewCompanyPopoverPreviewProps> = ({
  companyIdOrVat,
  company: externalCompany,
  trigger,
}) => {
  const {
    data: loadingCompany,
    isLoading: isCompanyLoading,
    error: companyError,
  } = useCompany(companyIdOrVat);

  const company = externalCompany || loadingCompany;

  return (
    <Popover
      trigger={trigger}
      hasArrow
    >
      <Spacing padding={25} css={styles.wrapper}>
        {(isCompanyLoading) && <PopoverPreviewSkeleton aria-label="Caricamento informazioni persona giuridica in corso" />}

        {companyError && (
          <Spacing padding={150}>
            <Message
              type="critical"
              message="Non è stato possibile caricare le informazioni della persona giuridica."
            />
          </Spacing>
        )}

        {company && (
          <PopoverPreview
            aria-label="Informazioni persona giuridica"
            title={company.name}
            details={`P. IVA ${company.vatNumber}`}
            avatar={<CompanyAvatar size="L" />}
          >
            <div css={styles.address}>
              <Icon path={ICON_MAP_MARKER_OUTLINE} size={20} />
              <Text.Body as="div">
                {company.address.normalizedAddress}
              </Text.Body>
            </div>
          </PopoverPreview>
        )}
      </Spacing>
    </Popover>
  );
};

export default ViewCompanyPopoverPreview;
